import dompurify from "isomorphic-dompurify";

import { useConfig } from "@jti/app-context/useConfig";
import { Button } from "@jti/core-components/components/Button";
import { I18n, useTranslations } from "@jti/ui";

import styles from "./ConsentText.module.scss";

const ALLOWED_TAGS = ["a", "b", "strong", "i", "em", "u", "small", "span"];
const ALLOWED_ATTR = ["href", "target", "rel"];

const sanitize = (html: string) => dompurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });

export const ConsentText = () => {
  const config = useConfig();
  const { __ } = useTranslations();

  return (
    <span className={styles.consentText}>
      <I18n t="cart.checkout.consent.text">
        <Button className={styles.link} variant="text" href={config.PRIVACY_PAGE_URL} target="_blank">
          {__("cart.checkout.consent.privacy_policy")}
        </Button>
        <Button className={styles.link} variant="text" href={config.TERMS_PAGE_URL} target="_blank">
          {__("cart.checkout.consent.terms_and_conditions")}
        </Button>
        <span dangerouslySetInnerHTML={{ __html: sanitize(__("cart.checkout.consent.html")) }} />
      </I18n>
    </span>
  );
};
